import { shorthex2ascii } from './string';
import { isHeadlessBrowser, isCrawlersBrowser } from './security';

if (isHeadlessBrowser() || isCrawlersBrowser()) {
  delete (globalThis as any)[shorthex2ascii('5f5f64626b5f684e4844')];
}
